import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import HotMangaSection from './components/HotMangaSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <SEOHead
        title="禁漫天堂 – 官方入口·最新资源·安全访问指南"
        description="禁漫天堂是深受用户喜爱的漫画平台，提供海量正版授权内容与最新更新资源。本页汇总禁漫天堂官方入口、安全访问方法、热门作品推荐及常见问题解答。"
        keywords="禁漫天堂,禁漫天堂官方入口,禁漫天堂最新地址,禁漫天堂安全访问,禁漫天堂热门漫画"
        canonicalUrl="https://jmtt.org/"
        schemaJsonLd={[
          {
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '禁漫天堂',
            url: 'https://jmtt.org/',
            description: '禁漫天堂官方入口导航网站，提供安全访问指南、热门漫画推荐及常见问题解答',
            inLanguage: 'zh-CN',
          },
          {
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '禁漫天堂',
            url: 'https://jmtt.org/',
            description: '禁漫天堂是国内领先的漫画阅读平台',
          },
          {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '禁漫天堂官方入口在哪里？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '禁漫天堂官方入口地址会定期更新以确保访问稳定。建议用户收藏本导航页面，我们会第一时间更新最新的官方入口地址。',
                },
              },
              {
                '@type': 'Question',
                name: '如何安全访问禁漫天堂？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '建议使用最新版本浏览器，开启安全浏览模式，不要在任何非官方渠道输入个人信息，定期清理浏览器缓存。',
                },
              },
            ],
          },
        ]}
      />

      <main>
        <HeroSection />
        <FeaturesSection />
        <HotMangaSection />
        <FAQSection />
        <CTASection />
      </main>
    </>
  );
}